import heroArt from './assets/art/hero-abstract.svg'
import aboutArt from './assets/art/about-abstract.svg'
import linkedinIcon from './assets/social-icons/linkedin.png'
import githubIcon from './assets/social-icons/github.jpg'
import twitterIcon from './assets/social-icons/twitter.png'

export const personalInfo = {
  name: 'Moksedul Alam',
  heading: 'IT Expert, Digital Solution Provider, Web/App Developer, Engineer, AutoCAD Expert',
  photo: heroArt,
  email: 'moksedul.design@gmail.com',
  whatsappNumber: '8801700000000', // placeholder: replace with the real number (country code, no +)
}

export const socials = [
  { id: 1, name: 'LinkedIn', link: 'https://www.linkedin.com/in/moksedul-alam/', icon: linkedinIcon },
  { id: 2, name: 'GitHub', link: 'https://github.com/Moksedul', icon: githubIcon },
  { id: 3, name: 'Twitter', link: 'https://twitter.com/moksedul_engr', icon: twitterIcon },
]

export const about = {
  image: aboutArt,
  description: 'I have experience of 3 years in Web Development, IT, and Digital Marketing. I am very passionate to Work in IT Industry, Web design /development, and any kind of Digital Industry',
  experience: '3+ Years Working',
  clients: '10+ Clients',
  projects: '7+ Completed Projects',
}

export const skills = [
  {
    id: 1,
    techName: 'Frontend Development',
    skills: [
      { id: 1, name: 'HTML', level: 'Experienced' },
      { id: 2, name: 'CSS', level: 'Intermediate' },
      { id: 3, name: 'JavaScript', level: 'Intermediate' },
      { id: 4, name: 'Bootstrap', level: 'Experienced' },
      { id: 5, name: 'React', level: 'Basic' },
      { id: 6, name: 'AJAX', level: 'Basic' },
    ],
  },
  {
    id: 2,
    techName: 'Backend Development',
    skills: [
      { id: 7, name: 'Python', level: 'Experienced' },
      { id: 8, name: 'Django', level: 'Experienced' },
      { id: 9, name: 'PHP', level: 'Basic' },
      { id: 10, name: 'PostgreSQL', level: 'Basic' },
      { id: 11, name: 'MySQL', level: 'Basic' },
      { id: 12, name: 'SQLite', level: 'Basic' },
      { id: 13, name: 'MSSQL', level: 'Basic' },
    ],
  },
]
